import React from 'react';
import Image from 'next/image';
import { Stack, Typography, useTheme, useMediaQuery } from '@mui/material';

import { Container } from '@/components/layout';
import getUrlToS3 from '@/utils/get-url-to-s3';

function OurStory() {
  const theme = useTheme();
  const isMobile = useMediaQuery(`${theme.breakpoints.down('lg')}`);

  return (
    <Stack
      sx={{
        justifyContent: 'flex-end',
        paddingTop: { xs: theme.spacing(6), md: theme.spacing(8) },
        paddingBottom: { xs: theme.spacing(13), md: theme.spacing(15) },
      }}
    >
      <Container>
        <Stack
          sx={{
            width: '100%',
            flexDirection: { xs: 'column', lg: 'row' },
            gap: { xs: theme.spacing(4.5), lg: theme.spacing(11) },
          }}
        >
          <Stack
            sx={{
              minWidth: '20%',
              backgroundColor: { xs: '#E3E6E7', lg: 'unset' },
              flexDirection: 'row',
              alignItems: { xs: 'center', lg: 'flex-start' },
              borderRadius: '16px',
              overflow: 'hidden',
            }}
          >
            <Stack
              sx={{
                width: { xs: '50%', lg: '100%' },
                aspectRatio: '0.720249221',
                position: 'relative',
                borderRadius: { xs: 'unset', lg: '16px' },
                overflow: 'hidden',
              }}
            >
              <Image
                src={getUrlToS3('/about/howItBegan.png')}
                layout="fill"
                objectFit="cover"
                objectPosition="center"
              />
            </Stack>

            {isMobile && (
              <Typography
                fontSize="3.125rem !important"
                lineHeight="1.18 !important"
                variant="h1"
                color="#52545F"
                sx={{
                  display: { xs: 'block', lg: 'none' },
                  textAlign: 'center',
                  width: '50%',
                }}
              >
                Our Story
              </Typography>
            )}
          </Stack>

          <Stack
            sx={{
              gap: theme.spacing(2),
              order: { xs: 1, md: 0 },
              minWidth: 0,
            }}
          >
            {!isMobile && (
              <Typography
                fontSize="3.125rem !important"
                lineHeight="1.18 !important"
                variant="h1"
                color="#52545F"
                sx={{
                  display: { xs: 'none', lg: 'block' },
                }}
              >
                Our Story
              </Typography>
            )}

            <Stack
              sx={{
                gap: theme.spacing(2.5),
              }}
            >
              <Typography
                variant="body2"
                color="#34353E"
                sx={{
                  fontSize: {
                    xs: '1.125rem !important',
                    md: '1.25rem !important',
                  },
                  lineHeight: { xs: '1.46 !important', md: '1.33 !important' },
                }}
              >
                OneVillage was born from a simple but powerful realization:
                navigating health shouldn’t be this hard.
              </Typography>

              <Typography
                variant="body2"
                color="#34353E"
                sx={{
                  fontSize: {
                    xs: '1.125rem !important',
                    md: '1.25rem !important',
                  },
                  lineHeight: { xs: '1.46 !important', md: '1.33 !important' },
                }}
              >
                Our founder and CEO, Ashley Yesayan, saw firsthand how complex
                and fragmented the healthcare experience can be. With a
                background in growing innovative consumer technology companies,
                she knew there had to be a better way—one that simplifies access
                to care, empowers individuals, and makes well-being a natural
                part of everyday life.
              </Typography>

              <Typography
                variant="body2"
                color="#34353E"
                sx={{
                  fontSize: {
                    xs: '1.125rem !important',
                    md: '1.25rem !important',
                  },
                  lineHeight: { xs: '1.46 !important', md: '1.33 !important' },
                }}
              >
                That vision became OneVillage, a platform designed to transform
                how people experience health. By bringing together personalized
                coaching, seamless benefits management, and engaging programs,
                we make it easier for employers and their people to get the
                support they need—whenever they need it. Because when health
                works better for everyone, we all thrive.
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
}

export default OurStory;
